import { render, staticRenderFns } from "./DomiciliationModal.vue?vue&type=template&id=8a0962b6&"
import script from "./DomiciliationModal.vue?vue&type=script&lang=js&"
export * from "./DomiciliationModal.vue?vue&type=script&lang=js&"
import style0 from "./DomiciliationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports